var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dj-media-icon-wrap",on:{"click":_vm.click}},[_c('div',{staticClass:"dj-user-not-select dj-icon- dj-media-icon",class:'dj-icon-'+_vm.media,style:({
           '--mediaSize':_vm.mediaSize,
           '--mediaColor':_vm.mediaColor,
           '--mediaWeight':_vm.mediaWeight,
           lineHeight:_vm.mediaLineHeight
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }